import Text from '@/ui/components/Text';

import styles from './PriceDropsEmptyMessage.module.css';

const PriceDropsEmptyMessage = () => {
  return (
    <div className={styles.priceDropsEmptyMessage}>
      <img
        alt="No price drops found!"
        src="/images/splash.svg"
      />

      <div className={styles.text}>
        <Text
          kind="heading-5"
          weight="600"
        >
          Dino is on the hunt!
        </Text>
        <Text
          kind="paragraph"
          size="regular"
        >
          Give it some time and keep an eye
          on your inbox to not miss anything.
        </Text>
      </div>
    </div>
  );
};

export default PriceDropsEmptyMessage;
